import { action } from 'satcheljs';
import getStore from '../store/Store';

export const getDefaultFeatureFlags = action('GET_DEFAULT_FEATURE_FLAGS', () => [
    ...getStore().defaultFlags.keys(),
]);
